<script setup lang="ts">
    import { CircleAlertIcon } from '@lucide/vue';
    import { __ } from '@/js/stores/expressions';
</script>

<template>
    <div class="WidgetGraphErrorState">
        <CircleAlertIcon class="WidgetGraphErrorState__icon size-8" aria-hidden="true" />
        <p class="WidgetGraphErrorState__title">
            {{ __('widget-graph-error-title') }}
        </p>
        <p class="WidgetGraphErrorState__description">
            {{ __('widget-graph-error-description') }}
        </p>
    </div>
</template>
